module.exports = __webpack_public_path__ + "static/media/Natural Colour.5e80814e.jpg";